import { IconButton } from "@mui/material";
import React, { Fragment, useState } from "react";
import { FiTablet } from "react-icons/fi";
import propTypes from "prop-types";

import styles from "../../../devices_admin/components/listItems/styles";
import flex from "../../../../../styles/flex";
import { Device } from "../../../../../logic/api";
import { useDate } from "../../../../../utility/useDate";
import { Block } from "@mui/icons-material";
import { useTranslation } from "react-i18next";

const DeviceListItem: React.FunctionComponent<{
    device: Device,
    onSelect: () => void,
}> = (props) => {
    const [device] = useState(props.device);
    const { toFormattedDateTimeString } = useDate();
    const { t } = useTranslation();

    let lastUser = [device.lastUser?.firstName ?? "", device.lastUser?.lastName ?? ""].filter((n) => n.length > 0).join(" ");
    if (lastUser.length == 0) lastUser = "-";

    const hasGPSFix = (((device.gpsLat ?? 0) != 0) && ((device.gpsLng ?? 0) != 0));

    return (
        <Fragment>
            <div style={{ ...styles.listItem, opacity: device.active == true ? 1 : 0.5 }}>
                <div style={{ ...flex.flexRows, justifyContent: "center", alignItems: "center" }}>

                    <div style={flex.flexAuto}>

                        <div style={{ marginRight: 10 }}>
                            <IconButton disabled={true}>
                                <FiTablet color={"black"}></FiTablet>
                            </IconButton>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>

                        <div>
                            <b>{((device.alias ?? "").length > 0 ? device.alias : device.name) ?? t("mobile.noName")}</b>
                        </div>
                        {
                            (device.alias ?? "").length > 0 && (
                                <div style={{ marginBottom: 5 }}>
                                    {device.name}
                                </div>
                            )
                        }

                        {
                            (device.appVersion ?? "").length > 0 && (
                                <div>
                                    <b>{device.appVersion}</b>
                                </div>
                            )
                        }
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.lastOnline")}
                        </div>
                        <div>
                            <b>{toFormattedDateTimeString(device.lastOnlineDate)}</b>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.lastSync")}:
                        </div>
                        <div>
                            <b>{(device.lastSyncDate == null) ? "NEVER" : toFormattedDateTimeString(device.lastSyncDate)}</b>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.lastUser")}
                        </div>
                        <div>
                            <b>{lastUser}</b>
                        </div>
                    </div>
                    <div style={{ ...flex.flexFill, textAlign: "left" }}>
                        <div>
                            {t("mobile.gpsLocation")}
                            {(hasGPSFix) && ((<b><small>&nbsp;{toFormattedDateTimeString(device.gpsDate)}</small></b>))}
                        </div>
                        <div>
                            {(hasGPSFix) && (
                                <div>
                                    <div>
                                        <b>
                                            <a target="_blank" rel="noreferrer" href={`https://www.google.com/maps/search/?api=1&query=${device.gpsLat},${device.gpsLng}`}>{device.gpsLat},{device.gpsLng}</a>
                                        </b>
                                    </div>
                                </div>
                            )}
                            {(!hasGPSFix) && (
                                <i>{t("mobile.noLocation")}</i>
                            )}

                        </div>
                    </div>


                    <div style={{ ...flex.flexAuto, textAlign: "center", minWidth: 80 }}>
                        <IconButton
                            onClick={() => {
                                props.onSelect();
                            }}
                        >
                            <Block></Block>
                        </IconButton>
                        <div><small>{t("mobile.deactivate")}</small></div>
                    </div>


                </div>
            </div >

        </Fragment>
    );
}

DeviceListItem.propTypes = {
    device: propTypes.any.isRequired,
    onSelect: propTypes.func.isRequired,
}

export default DeviceListItem;


